const initialData = {
  userData: [],
};

const userReducer = (state = initialData, action) => {
  switch (action.type) {
    case "ADD_USER_DATA":
      return { ...state, userData: action.payload };
    default:
      return state;
  }
};
export default userReducer;
